import { createActionGroup, props } from '@ngrx/store';
import { ProgramConfig, ProgramLpa } from '@tdf/rtpca-models';

export const programConfigApiActions = createActionGroup({
  source: 'Program Config API',
  events: {
    'Load Program Config': props<{ refinery: string }>(),
    'Load Program Config Success': props<{ programConfigs: ProgramConfig[] }>(),
    'Load Program Config Failure': props<{ error: string }>(),
    'Save Program Config': props<{ programConfig: ProgramConfig }>(),
    'Save Program Config Success': props<{ programConfig: ProgramConfig }>(),
    'Save Program Config Failure': props<{ error: unknown, refinery: string }>(),
    'Delete Program Config': props<{ programConfigId: number, refinery: string }>(),
    'Delete Program Config Success': props<{ programConfigId: number, refinery: string }>(),
    'Delete Program Config Failure': props<{ error: string }>(),
    'Load Available LPA Programs': props<{ refinery: string }>(),
    'Load Available LPA Programs Success': props<{ lpaPrograms: ProgramLpa[] }>(),
    'Load Available LPA Programs Failure': props<{ error: string }>(),
    'Set Update': props<{ isUpdate: boolean; id: number }>(),
    'Update Program': props<{ programConfigId: number; startDate: Date; endDate: Date, refinery: string }>(),
    'Update Program Success': props<{ programConfigId: number, refinery: string}>(),
    'Update Program Failure': props<{ error: unknown, refinery: string }>(),
  },
});
